import React, { useEffect, useState, useMemo } from "react";
import PaginationComp from "../../genericComponents/resizeableTable/PaginationComp";
import DynamicAlertDialog from "../../genericComponents/uiElements/DynamicAlertDialog";
import SearchOrAddDropdown from "../../AutoNurture/SideCardsForAutoNurture/childCompsForNurtureCard/NurtureCampaignContact/SearchOrAddDropdown";
import { pxToRem } from "../../../../utilities/uiUtils";
import DynamicAlertBoxGlobal from "../../genericComponents/uiElements/DynamicAlertBoxGlobal";
import { Info } from 'react-feather';
import TextWithTooltip from "../../GlobalContacts/TextWithTooltip";
export default function KeyDevelopmentsForAccount({
  numOfDevelopments,
  recentDevelopmentsData = [],
  loading
}) {
  // Filters
  console.log("skeleton-text",loading)
  const allTypes = useMemo(
    () => ["All", ...new Set(recentDevelopmentsData.map((d) => d.type))],
    [recentDevelopmentsData]
  );
  const [selectedType, setSelectedType] = useState("All");
  const [alertConfig, setAlertConfig] = useState({
    show: false,
    title: "",
    message: "",
    type: "info",
  });

  const handleViewDetails = (dev) => {

    setAlertConfig({
      show: true,
      title: dev?.type || "Key Development",
      message: dev?.headline || "No details available",
      type: "info",
    });
  };

  // Pagination
  const ITEMS_PER_PAGE = 8;
  const [page, setPage] = useState(1);

  const filteredData = useMemo(() => {
    return selectedType === "All"
      ? recentDevelopmentsData
      : recentDevelopmentsData.filter((d) => d.type === selectedType);
  }, [selectedType, recentDevelopmentsData]);

  const pageData = useMemo(() => {
    const start = (page - 1) * ITEMS_PER_PAGE;
    return filteredData.slice(start, start + ITEMS_PER_PAGE);
  }, [page, filteredData]);

  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);

  const formatDate = (str) => {
    const d = new Date(str);
    return d.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };
  const mapToOption = (arr) => arr.map((val) => ({ label: val, value: val }));
  const onPageChange = (pg) => {
    setPage(pg);
  };

  useEffect(() => {
    setPage(1); // reset page when filter changes
  }, [selectedType]);
console.log(recentDevelopmentsData);

  console.log("alertConfig.show", alertConfig.show);
  return (
    <div style={{ padding: "16px" }}>
      {/* Header */}
     {numOfDevelopments > 0&& <div
        style={{
          display: "flex",
          // justifyContent: "space-between",
          justifyContent: "flex-end",
          marginBottom: "12px",
        }}
      >
        {/* Filter */}
        <span style={{ width: "10rem" }}>
          <SearchOrAddDropdown
            placeholder="key development filters"
            options={mapToOption(allTypes)}
            value={selectedType}
            onChange={setSelectedType}
            mode="single"
            showCount={false}
            className="stf-input"
            searchMode="search-only"
          />
        </span>
      </div>}

      {/* Cards Grid */}
      {loading ?
        <div className="kd-grid">
          {[...Array(8)].map((_, index) => (
            <div key={index} className="kd-card">
              <div className="kdc-skeleton">
                <div className="kdc-skeleton-image"></div>
                <div className="kdc-skeleton-text short"></div>
              </div>
            </div>
          ))}
        </div>

        :
        <div className="kd-grid">
          {pageData.map((item, index) => (
            <div key={index} className="kd-card">
              <TextWithTooltip text={item.type} className="kd-title" />
              <TextWithTooltip text={item.headline} className="kd-headline" />
              <div className="kd-footer">
              <div className="kd-date">{formatDate(item.date)}</div>
              <button
                onClick={() => handleViewDetails(item)}
                className="kd-action"
              >
                <Info color="#a0c6f0ff" size={20} />
              </button>
            </div>


            </div>
          ))}
        </div>}

      {/* {pageData.length === 0 && <div>No developments available.</div>} */}

      {totalPages > 1 && (
        <div
          className="generic-table_pagination-comp-wrapper"
          style={{ marginTop: "16px" }}
        >
          <PaginationComp
            currentPage={page}
            itemsPerPage={ITEMS_PER_PAGE}
            onPageChange={onPageChange}
            totalItems={filteredData.length}
          />
        </div>
      )}

      <DynamicAlertBoxGlobal
        title={alertConfig.title}
        message={alertConfig.message}
        type={alertConfig.type}
        show={alertConfig.show}
        onClose={() =>
          setAlertConfig({
            show: false,
            title: "",
            message: "",
            type: "info",
          })
        }
      />


      {/* Inline CSS */}
      <style>{`

.kdc-skeleton {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 16px;
}

.kdc-skeleton-image {
  width: 100%;
  height: 120px;
  background: #e0e0e0;
  border-radius: 8px;
  animation: shimmer 1.5s infinite linear;
}

.kdc-skeleton-text {
  height: 16px;
  background: #e0e0e0;
  border-radius: 4px;
  animation: shimmer 1.5s infinite linear;
}

.kdc-skeleton-text.short {
  width: 40%;
}

.kdc-skeleton-text.long {
  width: 80%;
}

@keyframes shimmer {
  0% {
    background-position: -200px 0;
  }
  100% {
    background-position: 200px 0;
  }
}

.kdc-skeleton-image,
.kdc-skeleton-text {
  background: linear-gradient(
    90deg,
    #e0e0e0 25%,
    #f0f0f0 50%,
    #e0e0e0 75%
  );
  background-size: 400px 100%;
}




        // .kd-grid {
        // display: grid;
        // grid-template-columns: repeat(1, 1fr);
        // gap: 12px;
        // height:${pxToRem(400)};
        // max-height:${pxToRem(400)}
        // }
        .kd-grid {
          display: grid;
          grid-template-columns: repeat(1, 1fr);
          gap: 12px;
          align-items: stretch;
        }


        /* Tablet */
        @media (min-width: 600px) {
        .kd-grid {
            grid-template-columns: repeat(2, 1fr);
        }
        }

        /* Desktop - 4 columns */
        @media (min-width: 900px) {
        .kd-grid {
            grid-template-columns: repeat(4, 1fr);
        }
        }

        
        //  .kd-card {
        //   display: flex;
        //   flex-direction: column;
        //   min-height: 140px;
        //   max-height: 100%;
        //   background: #fff;
        //   border: 1px solid #eee;
        //   border-radius: 10px;
        //   padding: 14px;
        //   overflow: hidden; 
        //   box-sizing: border-box;
        //   word-break: break-word;
        // }
        .kd-card {
          display: flex;
          flex-direction: column;
          background: #fff;
          border: 1px solid #eee;
          border-radius: 10px;
          padding: 14px;
          box-sizing: border-box;
          word-break: break-word;
          height: ${pxToRem(200)}; /* ✅ Add this line */
        }


        
        .kd-title {
        font-weight: 400;
        font-size: 15px;
        margin-bottom: 5px;
        }

        .kd-headline {
        color: #555;
        font-size: 12px;
        margin-bottom: auto;
        line-height: 1.4;
        }
        .kd-title {
          font-weight: 400;
          font-size: 15px;
          margin-bottom: 5px;

          display: -webkit-box;        /* enable multi-line truncation */
          -webkit-line-clamp: 2;       /* limit to 2 lines */
          -webkit-box-orient: vertical;
          overflow: hidden;             /* hide overflowing content */
          text-overflow: ellipsis;      /* show ellipsis */
        }
        .kd-headline {
          color: #555;
          font-size: 12px;
          line-height: 1.4;
          margin-bottom: auto;

          display: -webkit-box;        /* necessary for line-clamp */
          -webkit-line-clamp: 3;       /* limit to 3 lines */
          -webkit-box-orient: vertical;
          overflow: hidden;             /* hide overflowing content */
          text-overflow: ellipsis;      /* show ellipsis after 3 lines */
        }



        
        .kd-date {
          font-size: 12px;
          color: #777;
          white-space: nowrap;       /* prevent wrapping */
          overflow: hidden;          /* hide overflow */
          text-overflow: ellipsis;   /* show ellipsis */
          flex-grow: 1;              /* take up remaining space */
          margin-right: 8px;         /* space from the button */
        }

        

.kd-footer {
  display: flex;
  justify-content: space-between; /* keep button on right */
  align-items: center;
  margin-top: 0px;
  gap: 8px; /* space between items */
}




.kd-action {
  flex-shrink: 0;            /* keep button size fixed */
  background: transparent;
  border: none;
  font-size: 20px;
  cursor: pointer;
}
        .kd-action:hover {
        opacity: 0.6;
        }
      `}</style>
    </div>
  );
}
